import React from 'react';
import Sidebar from '../components/Sidebar';

const AdminLayout = () => {
  return <Sidebar />;
};

export default AdminLayout;
